


<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>



<script>
  import Vue from 'vue'
  import './assets/js/flexible.js'
  import api from './api/common/api.common'
  // 注册
  Vue.filter('filterPrice', function (value) {
    return value ? (value/100).toFixed(2) : 0;
  })
   Vue.filter('filterPhone', function (val) {
    let value = String(val);
    let first = value.substring(0,3);
    let second = value.substring(3,7);
    let third = value.substring(7,11);
    return val ? first+' '+second+' '+third : null;
  })


//  import routes from 'vue-router'
  export default {
    name: 'app',
    mounted () {
      this.$router.beforeEach(function (to,from,next) {

        if (to.path.indexOf('/home') !== -1 || to.path === '/') {
          console.log(to)
        } else {
          window.scrollTo(0, 0)
        }

        next();
      })
    },
    methods: {
      dealGetUserInfoErr ( isAttention, url) {

        if (window.location.origin.indexOf('wap.blissmall.net') === -1 ) {
          return
        }
        // 如果已经关注过公众号，则不处理
        if (isAttention && isAttention == true) {
          return
        }

        var lastTimeStr = localStorage.getItem('lastPopGetUserInfo-timeCache')
        // 如果最后弹出时间已经过了23小时，则跳转到弹出确认获取信息的openWX链接
        if (lastTimeStr) {

          var lastTime = new Date(lastTimeStr)
          lastTime.setTime(lastTime.getTime()+23*60*60*1000)
          var nowTime = new Date()
          if (nowTime > lastTime) {
            localStorage.setItem('lastPopGetUserInfo-timeCache',nowTime)
            window.location.href = url
          }

        } else { // 如果没有记录弹出时间（第一次）,则直接跳转
          var nowTime = new Date()
          localStorage.setItem('lastPopGetUserInfo-timeCache',nowTime)
          window.location.href = url
        }

      },
      dealWXSign () {
        var code = this.utils.getUrlKey('code')
        var stateVal = this.utils.getUrlKey('state')
        var self = this
       var origin = window.location.origin
        var state = ''
        if (this.$route.fullPath.length > 1) {
          state = '&state=' + this.$route.fullPath
        }
        
        // if( process.env.NODE_ENV == 'qa001' || process.env.NODE_ENV == 'qa002' || process.env.NODE_ENV == 'qa003' ){
        // 幸福商城科技公众号 暂停测试
          // var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx674e8a68779fd71f&redirect_uri=' + origin + '&response_type=code&scope=snsapi_base' + state + '#wechat_redirect'
          // var getUserInfoUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx674e8a68779fd71f&redirect_uri=' + origin + '&response_type=code&scope=snsapi_userinfo' + state + '#wechat_redirect'
          
        // }else if( process.env.NODE_ENV == 'prod' || process.env.NODE_ENV == 'prodWx' ) {
        // 
        // //线上微信公众号
          var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx08dc80f9bee15b99&redirect_uri=' + origin + '&response_type=code&scope=snsapi_base' + state + '#wechat_redirect'
          var getUserInfoUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx08dc80f9bee15b99&redirect_uri=' + origin + '&response_type=code&scope=snsapi_userinfo' + state + '#wechat_redirect'
       
        // }
       
        // 当链接地址里面有code的时候(从openWX跳转的页面)，自动进行微信登录
        if (code !== null) {

          var data = {}
          data.code = code

          api.wxAutoSign(data,function (respond) {
            // debugger
            // alert(respond.body.data['userId'])
            localStorage.setItem('isWxLogin-cache', true)
            if (respond.body.data['userId'] !== undefined) {
              localStorage.setItem('userIsLogin', true)
            } else {
              localStorage.setItem('userIsLogin', false)
            }
            // 记录登录时间
            localStorage.setItem('userloginTime', new Date());
            localStorage.setItem('loginCredentials', respond.body.data['loginCredentials']);
            // 当用户没有关注过公众号，获取用户信息失败的时候进行处理
            self.dealGetUserInfoErr(respond.body.data['subscribe'],getUserInfoUrl)
//            self.dealGetUserInfoErr(false,getUserInfoUrl)
            self.utils.delParama('code')
            if (stateVal !== null && stateVal !== undefined && stateVal.length > 0) {
//              var newState = stateVal.replace(/[%2F]/g,'/')
              self.$router.replace(stateVal)
            }

          },function (err) {
            debugger
            localStorage.setItem('isWxLogin-cache', false)
            localStorage.setItem('userIsLogin', false)
            if (stateVal !== null && stateVal !== undefined && stateVal.length > 0) {
//              var newState = stateVal.replace(/[%2F]/g,'/')
              self.$router.replace(stateVal)
            }
          },false)

        } else if ( self.utils.isWXUA() ) // 当链接地址没有code且在微信中打开时，判断是否跳转到openWX进行登录
        {

          if (window.location.origin.indexOf('wap.blissmall.net') === -1 ) {
            return
          }

          var userloginTime = localStorage.getItem('userloginTime')
          var time = new Date(userloginTime)
          time.setTime(time.getTime()+24*60*60*1000);
          var now = new Date()

          // 当微信没有登录过，跳转到openWX进行登录
          if (!self.utils.isWxLogin() ) {
            window.location.href = url
          } else if (userloginTime !== null && now > time) // 当已经微信登录，但是超过24小时的重新跳转到openWX进行登录
          {
            window.location.href = url
          }

        }
      },
    },
    created () {
      this.dealWXSign()
      console.log('v1.0.3')
    }
  }
</script>

<style src="./assets/css/reset.css" lang="css"></style>
<style src="./assets/css/mint-ui-reset.scss" lang="scss"></style>
<style src="./assets/css/public.scss" lang="scss"></style>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
/*  color: #2c3e50;
  margin-top: 0px;*/
}
</style>



// WEBPACK FOOTER //
// App.vue?66b4aa9e